import classnames from 'classnames';

import inputStyle from '../Input.module.scss';
import style from './PhoneInput.module.scss';

import { CountryCode } from 'chaika-enums';

import { InputLayout, InputLayoutProps } from '../InputLayout';
import { MaskedControl } from '../MaskedInput/MaskedControl';
import { CountrySelect, CountrySelectTheme } from '../../Select';
import { phoneCountryOptions } from './phoneCountryOptions';
import { usePhoneInput } from './hooks/usePhoneInput';

export interface PhoneInputProps
    extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>, InputLayoutProps {
    value: string | number;
    dataTest?: string;
    country?: CountryCode;
    additionalClassNames?: string;
    onCountryChange?(newValue: string): void;
    onChangeValue?(value: string, name?: string): void;
    onBlur?(event: React.FocusEvent<HTMLInputElement>): void;
    onFocus?(event: React.FocusEvent<HTMLInputElement>): void;
}

export function PhoneInput({
    value = '',
    country,
    disabled,
    placeholder,
    additionalClassNames,
    dataTest,
    leftTitle,
    title,
    titleHint,
    theme,
    modifiers,
    notValidText,
    iconLinkProps,
    isValid,
    isRequired,
    isImportant,
    showValidStatus,
    onChangeValue,
    onBlur,
    onFocus,
    onCountryChange,
    ...props
}: PhoneInputProps) {
    const {
        phone,
        countryCode,
        phoneMask,
        isOnFocus,
        setPhoneInput,
        handlePhoneValueChange,
        handleCountrySelect,
        handleFocus,
        handleBlur,
    } = usePhoneInput({ value, country, name: props.name, onChangeValue, onBlur, onFocus, onCountryChange });

    return (
        <InputLayout
            isOnFocus={isOnFocus}
            isEmpty={!phone || phone === ''}
            disabled={disabled}
            overflowVisible
            leftTitle={leftTitle}
            title={title}
            titleHint={titleHint}
            theme={theme}
            modifiers={modifiers}
            notValidText={notValidText}
            iconLinkProps={iconLinkProps}
            isValid={isValid}
            isRequired={isRequired}
            isImportant={isImportant}
            showValidStatus={showValidStatus}
        >
            <div className={classnames([style.root])}>
                <div className={style.countrySelect}>
                    <CountrySelect
                        countryOptions={phoneCountryOptions}
                        theme={CountrySelectTheme.Inline}
                        selectedCountry={countryCode}
                        onCountrySelect={handleCountrySelect}
                        disabled={disabled}
                    />
                </div>
                <MaskedControl
                    {...props}
                    className={classnames([inputStyle.input, style.input, additionalClassNames])}
                    dataTest={dataTest}
                    type={'tel'}
                    inputRef={setPhoneInput}
                    value={phone}
                    mask={phoneMask}
                    disabled={disabled}
                    alwaysShowMask={true}
                    placeholder={placeholder}
                    formatChars={{
                        '#': /[0-9]/,
                    }}
                    onChangeValue={handlePhoneValueChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                />
            </div>
        </InputLayout>
    );
}
